<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="2"></ucMenu>
          <div class="right_con">
            <div class="goods_main" v-loading="isLoading">
              <p class="fb">商品中心</p>
              <!-- 店铺类型切换：1 抖店，7 微信；默认抖店 -->
              <div class="platform_tabs_wrap">
                <p class="platform_tab" :class="searchData.shop_type==1 ? 'active' : ''" @click="bindShopTypeChange(1)">抖店</p>
                <p class="platform_tab" :class="searchData.shop_type==7 ? 'active' : ''" @click="bindShopTypeChange(7)">微信</p>
              </div>
              <div class="select_wrap">
                <div class="search_fields">
                <!-- <el-select class="w290" v-model="searchData.shop_type" placeholder="请选择" clearable filterable >
                  <p slot="prefix" class="label_title">店铺类型</p>
                  <el-option v-for="item in shopTypeList" :key="item.val" :label="item.text" :value="item.val">
                  </el-option>
                </el-select> -->
                <el-select class="w290" @clear="onShopChange" @change="onShopChange" v-model="searchData.shop_id" placeholder="请选择" clearable filterable >
                  <p slot="prefix" class="label_title">店铺名</p>
                  <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
                  </el-option>
                </el-select>
                <!--								<el-select class="w290" v-model="searchData.dangkou_id" placeholder="请选择" clearable filterable >
                                  <p slot="prefix" class="label_title">档口</p>
                                  <el-option v-for="item in dangkouList" :key="item.dangkou_id" :label="item.full_txt" :value="item.dangkou_id">
                                  </el-option>
                                </el-select>-->

                <!--								<div class="w290">
                                  <p  class="label_title cate-label">分类</p>
                                  <el-cascader
                                      v-model="searchData.cate_id"
                                      placeholder="请选择"
                                      :options="cateList"
                                      clearable
                                      filterable>
                                      </el-cascader>
                                </div>-->

                <el-input class="w290" v-model="searchData.product_title" placeholder="请输入内容">
                  <p slot="prefix" class="label_title">商品名称</p>
                </el-input>
                <el-input class="w290" v-model="searchData.platform_product_id" placeholder="请输入内容">
                  <p slot="prefix" class="label_title">商品ID</p>
                </el-input>
                <el-input class="w290 source-id-input" v-model="searchData.cloud_source_product_id" placeholder="请输入内容">
                  <p slot="prefix" class="label_title">云商品来源ID</p>
                </el-input>
                </div>

                <!--								<el-date-picker class="w290"-->
                <!--									v-model="searchData.search_date"-->
                <!--									type="datetimerange"-->
                <!--									align="right"-->
                <!--									unlink-panels-->
                <!--									size="small"-->
                <!--									range-separator="至"-->
                <!--									start-placeholder="开始日期"-->
                <!--									end-placeholder="结束日期"-->
                <!--									value-format="yyyy-MM-dd HH:mm:ss"-->
                <!--									@onPick="datePick"-->
                <!--									:picker-options="pickerOptions"-->
                <!--									:default-time="['00:00:00', '23:59:59']">-->
                <!--								</el-date-picker>-->

                <div class="search_actions">
                <el-button plain size="small" @click="handleSearch()">查询</el-button>
                <el-button plain size="small" @click="resetSearch()">重置</el-button>
                <el-button type="warning"  plain size="small" @click="openBixi()" :loading="openLoading" v-if="searchData.shop_type===1">低效商品</el-button>
                <el-button type="primary"  plain size="small" @click="openCleanBixi()" :loading="openLoading" v-if="searchData.shop_type===1">清理商品</el-button>
                </div>

              </div>
              <div class="tabs_wrap">
                <template v-if="searchData.shop_type === 1">
                  <p
                    v-for="tab in doudianStatusTabs"
                    :key="tab.key"
                    class="tab"
                    :class="activeDoudianTab === tab.key ? 'active' : ''"
                    @click="bindDoudianState(tab.key)"
                  >{{ tab.label }} <span class="tab-count">{{ getDoudianStatusCount(tab) }}</span></p>
                </template>
                <template v-else>
                  <p class="tab" :class="state==0?'active':''" @click="bindSate(0)">全部商品</p>
                  <p class="tab" :class="state==3?'active':''" @click="bindSate(3)">售卖中</p>
                  <p class="tab" :class="state==4?'active':''" @click="bindSate(4)">仓库中</p>
                  <p class="tab" :class="state==6?'active':''" @click="bindSate(6)">草稿箱</p>
                  <p class="tab" :class="state==5?'active':''" @click="bindSate(5)">审核不通过</p>
                  <p class="tab" :class="state==1?'active':''" @click="bindSate(1)">待铺货</p>
                  <p class="tab" :class="state==2?'active':''" @click="bindSate(2)">铺货失败</p>
                </template>
              </div>
              <div class="totals_btn">
                <p class="totals">共{{page_data.total}}条</p>
                <el-button v-if="searchData.shop_type === 1 && activeDoudianTab === 'selling'" plain size="small" @click="showFeatureInProgress">滞销商品下架</el-button>
                <el-button v-if="searchData.shop_type === 1 && activeDoudianTab === 'off_shelf_reminder'" plain size="small" @click="showFeatureInProgress">批量关联</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['all', 'selling', 'warehouse', 'draft', 'review_rejected', 'off_shelf_reminder'].includes(activeDoudianTab)" plain size="small" @click="openFilteredDoudianEditor">商品编辑</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['selling', 'warehouse', 'draft'].includes(activeDoudianTab)" plain size="small" @click="showFeatureInProgress">批量改价</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['selling', 'warehouse', 'draft', 'off_shelf_reminder'].includes(activeDoudianTab)" plain size="small" @click="showFeatureInProgress">批量改发货时间</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['warehouse', 'draft'].includes(activeDoudianTab)" plain size="small" :disabled="!checkList.length" @click="postBatOnSale">批量上架</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['selling', 'draft', 'off_shelf_reminder'].includes(activeDoudianTab)" plain size="small" :disabled="!checkList.length" @click="postBatOffSale">批量下架</el-button>
                <el-button v-if="searchData.shop_type === 1 && activeDoudianTab === 'pending'" plain size="small" @click="showFeatureInProgress">停止铺货</el-button>
                <el-button v-if="searchData.shop_type === 1 && activeDoudianTab === 'distribute_failed'" plain size="small" @click="showFeatureInProgress">一键重铺</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['selling', 'warehouse', 'draft', 'banned', 'review_rejected', 'off_shelf_reminder', 'pending', 'distribute_failed'].includes(activeDoudianTab)" plain size="small" :disabled="!checkList.length" @click="postBatProductDel">批量删除</el-button>
                <el-button v-if="searchData.shop_type === 1 && ['off_shelf_reminder', 'pending', 'distribute_failed'].includes(activeDoudianTab)" plain size="small" type="danger" @click="showFeatureInProgress">全部删除</el-button>
                <el-button v-if="searchData.shop_type !== 1" plain size="small" @click="postBatOnSale">批量上架</el-button>
                <el-button v-if="searchData.shop_type !== 1" plain size="small" @click="postBatOffSale">批量下架</el-button>
                <!--								<el-button plain size="small" @click="bindBatEditPrice">批量改价</el-button>
                                <el-button plain size="small" v-if="state !==2" @click="postBatOffSale">放入仓库</el-button>
                                <el-button plain size="small" @click="postSyncProduct" :loading="queue_num>0">{{queue_num>0?'正在同步':'一键同步'}}</el-button>-->
                <el-button
                  v-if="searchData.shop_type===1 && ['all', 'selling', 'warehouse', 'draft'].includes(activeDoudianTab)"
                  plain
                  size="small"
                  @click="postSyncProduct"
                  :loading="syncSubmitting"
                >一键同步</el-button>
                <el-button v-if="searchData.shop_type !== 1" plain size="small" @click="postBatProductDel">批量删除</el-button>
                <!--                                <el-button plain size="small" @click="goToEdit" >编辑提交</el-button>
                                                <el-button plain size="small" @click="goToLink()" >批量关联</el-button>
                                <el-button plain size="small" @click="reSubmit" v-if="state!=5">一键重铺</el-button>
                                <el-button plain size="small" @click="deleteAll" v-if="state!=0">全部删除</el-button>-->
                <el-button v-if="searchData.shop_type !== 1" plain size="small" type="danger" @click="clearCheck">清空已选</el-button>
                <!--				                <el-button plain size="small" @click="importGoods()">导入</el-button>-->
              </div>
              <div class="list_title">
                <label class="checkall">
                  <el-checkbox v-model="checkAll" @change="bindCheckAll"></el-checkbox>
                </label>
                <p class="t1">货品信息</p>
                <!--								<p class="t2">店铺名</p>-->
                <p class="t3">采购价</p>
                <p class="t4">卖价</p>
                <p class="t5">商品状态</p>
                <p v-if="searchData.shop_type===1" class="t7" :class="searchData.sales_sort==1?'up':searchData.sales_sort==2?'down':''" @click="bindSort">
                  销量
                  <i class="iconfont icon-sanjiao up"></i>
                  <i class="iconfont icon-sanjiao down"></i>
                </p>
                <p class="t6">铺货时间</p>
                <p class="t8">操作</p>
              </div>
              <ul class="goods_list">
                <el-checkbox-group v-model="checkList" @change="bindCheckList">
                  <li v-for="(item,index) in list" :key="index">
                    <div class="check_box"><el-checkbox :label="item.id" :key="item.id" :checked="item.checked"></el-checkbox></div>
                    <div class="goods_info">
                      <div class="img_box"><img class="coverimg" :src="item.img"  /></div>

                      <div class="con_box">
                        <p class="title">{{item.product_title}}</p>
                        <p class="nums">ID：{{item.platform_product_id}}</p>
                        <p class="nums">店铺：{{item.shop_name}}</p>
                        <!--												<p class="nums">ID：{{item.goods_id?item.goods_id:'-'}}</p>-->
                        <!-- <p class="nums">档口：{{item.dangkou?item.dangkou.full_txt:'-'}}</p> -->
                      </div>
                    </div>
                    <!--										<div class="dp_name">{{item.shop_name}}</div>-->
                    <p class="price1">￥{{item.product_price}}</p>
                    <p class="price2">￥{{item.distribute_price}}</p>
                    <div style="width: 90px">
                      <!-- 商品状态 -->
                      <!--											<p class="status sales" v-if="item.check_status == 3 && item.status == 0">售卖中</p>
                                            <p class="status xiajia" v-if="item.check_status == 3 && item.status == 1">已下架</p>
                                            <p class="status xiajia" v-if="item.check_status == 3 && item.status == 2">已删除</p>
                                            <p class="status fail"  style="width: 150px;" v-if="item.check_status != 3">{{item.check_status_text}}</p>
                                            &lt;!&ndash; 修改状态 &ndash;&gt;
                                            &lt;!&ndash; <p class="status sales" v-if="item.mod_status == 0">{{item.mod_status_text}}</p> &ndash;&gt;
                                            <p class="status xiajia" slot="reference" v-if="item.mod_status != 0 && item.status==1" @click="showError(item.error)">{{item.mod_status_text}}<i class="el-icon-warning"></i></p>

                                            <p class="status fail" v-if="item.off_shelves_remind == 1" @click="showError('供应商商品已下架,请及时更换供应商或下架商品')">下架提醒 <i class="el-icon-warning"></i></p>
                                            <p class="status fail" style="width: 150px;" v-if="item.delete_err_msg !=''" @click="showError(item.delete_err_msg)">删除失败原因 <i class="el-icon-warning"></i></p>-->

                      <el-tooltip  placement="top"  v-if="item.distribute_status==5||item.platform_status==2">
                        <template #content>
                          <div style="max-width: 200px">{{item.platform_error_msg}}</div>
                        </template>
                        <el-tag type="danger" size="small" >{{ getProductStatusText(item) }} </el-tag>
                      </el-tooltip>
                      <el-tag  size="small" type="success" v-else>{{ getProductStatusText(item) }}</el-tag>
                      <el-tag
                        v-for="badge in (item.status_badges || [])"
                        :key="badge.code"
                        size="small"
                        :type="badge.code === 'banned' ? 'danger' : 'warning'"
                      >{{ badge.text }}</el-tag>

                    </div>
                    <p v-if="searchData.shop_type===1" class="sales_num">{{item.sales_num || 0}}</p>
                    <p class="time">{{item.created_at}}</p>
                    <div class="last">
                      <!--											<a v-if="item.mod_status == 0" @click="goToLink(item.id)" class="guanlian">关联产品</a>-->
                      <!--											<p v-if="item.product_id" >
                                              <a v-if="item.product_id" :href="'/detail?id='+item.product_id" target="_blank" class="guanlian">查看商品</a>
                                            </p>-->
                      <p class="opts" v-if="canOperateProduct(item)" @click="bindSale(item)">
                        {{ getProductOperationText(item) }}</p>
                      <!--											<p class="opts" v-if="item.check_status == 3 && item.status == 1 && item.mod_status == 0" @click="bindOnSale(item.id)">上架</p>-->
                      <p
                        class="opts"
                        v-if="searchData.shop_type === 1 && !['off_shelf_reminder', 'distribute_failed'].includes(activeDoudianTab) && Number(item.platform_product_id) > 0"
                        @click="openDoudianEditor(item)"
                      >编辑</p>
                      <p class="opts" @click="handleViewCloudProduct(item)">查看云商品</p>
                      <p class="opts" @click="handleViewReplaceLogs(item)">SKU替换记录</p>
                      <p class="opts" @click="handleViewProductMarks(item)">查看标记货源</p>
                      <p class="opts"  @click="postOpProductDel(item)">移除</p>
                    </div>
                  </li>
                </el-checkbox-group>
                <li class="nodata" v-if="page_data.total == 0">暂无数据</li>
              </ul>
            </div>
            <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.page_size"
                        @pagination="getList" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[20,50,100,200,500,1000]" />
          </div>
        </div>
      </div>
      <!-- 选择改价策略 -->
      <el-dialog title="批量改价" :visible.sync="dialog.editPriceDialog" width="500px" center >
        <pricePloy @submit="postBatEditPrice" @close="dialog.editPriceDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.editPriceDialog"></pricePloy>
      </el-dialog>
    </div>
    <shopList ref="child"></shopList>
    <myFoot></myFoot>
    <div id="huhu"></div>
    <div id="huhu_clean"></div>
    <Bixi :data="componentConfig" />

    <importform :shop_id="searchData.shop_id" :show.sync="showImportDialog" @refesh_list="getList"></importform>

    <!-- 替换日志弹窗 -->
    <el-dialog title="替换记录" :visible.sync="replaceLogShow" width="600px" append-to-body>
      <div v-loading="replaceLogLoading">
        <div class="replace-log-tip">点击链接可查看详情</div>
        <el-table :data="replaceLogList" :header-cell-style="{ background: '#eef1f6', color: '#606266' }" max-height="400">
          <el-table-column label="时间" prop="created_at_text" width="180" align="center"></el-table-column>
          <el-table-column label="链接" align="center">
            <template #default="{ row }">
              <a :href="row.url" target="_blank" class="replace-log-link">{{ row.url }}</a>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-if="replaceLogList.length === 0 && !replaceLogLoading" description="暂无替换记录" :image-size="80"></el-empty>
        <Pagination
            v-if="replaceLogPageData.total > 0"
            :total="replaceLogPageData.total"
            :page.sync="replaceLogPageData.page"
            :limit.sync="replaceLogPageData.limit"
            @pagination="getReplaceLogData"
            layout="total, prev, pager, next"
        />
      </div>
    </el-dialog>

    <el-dialog title="查看标记货源" :visible.sync="productMarkViewShow" width="1100px" append-to-body>
      <el-empty v-if="!productMarkViewLoading && !productMarkViewItems.length" description="无标记数据"></el-empty>
      <el-table v-else v-loading="productMarkViewLoading" :data="productMarkViewItems" border max-height="520">
        <el-table-column label="图片" width="90" align="center">
          <template #default="{ row }"><el-image v-if="row.image" :src="row.image" fit="cover" style="width:65px;height:65px" :preview-src-list="[row.image]"></el-image><span v-else>-</span></template>
        </el-table-column>
        <el-table-column label="标题" min-width="220" prop="title" show-overflow-tooltip></el-table-column>
        <el-table-column label="商品ID" width="145"><template #default="{ row }">{{ row.offer_id || '-' }}</template></el-table-column>
        <el-table-column label="价格" width="90"><template #default="{ row }">{{ row.price || '-' }}</template></el-table-column>
        <el-table-column label="商家名称" width="130" prop="shop_name" show-overflow-tooltip></el-table-column>
        <el-table-column label="标记时间" width="170" align="center"><template #default="{ row }">{{ row.mark_at_text || '-' }}</template></el-table-column>
        <el-table-column label="操作" width="110" align="center">
          <template #default="{ row }"><el-button size="mini" plain @click="openProductMark(row)">查看商品</el-button></template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <doudian-product-editor-dialog
      :visible.sync="editorVisible"
      :product-id.sync="currentEditProductId"
      :search-params="searchData"
      :goods-status="state"
      :tab-status="activeDoudianTabConfig.tabStatus"
      :shop-type="searchData.shop_type"
      :sidebar-mode="editorSidebarMode"
      :initial-sidebar-page="page_data.page"
      :initial-sidebar-page-size="page_data.page_size"
      :sidebar-items="editorSidebarItems"
      @saved="handleDoudianEditorSaved"
    />

  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import pricePloy from '../../components/pricePloy/pricePloy';
import shopList from '../../components/shopList/shopList';
import importform from '../../components/imporform/importantform';
import xlsx from '../../assets/js/utils/xlsx.core.min.js';
import { Bixi } from '@open-fxg/bixi-vue';
import DoudianProductEditorDialog from './components/DoudianProductEditorDialog.vue';

export default {
  name: "ucenterGoods",
  components: {
    myHead, myFoot, ucMenu, Pagination, pricePloy, shopList, importform, Bixi, DoudianProductEditorDialog
  },
  data() {
    return {
      showImportDialog:false,
      isLoading: false,
      shopTypeList: [],
      shopList: [],
      cateList: [],
      dangkouList: [],
      checkAll: false,
      checkList: [],
      searchData:{
        sales_sort:0,
        // 店铺类型：1 抖店，7 微信；默认抖店
        shop_type: 1
      },
      state:0,
      activeDoudianTab: 'all',
      statusStatistics: {
        total: 0,
        selling: 0,
        warehouse: 0,
        draft: 0,
        banned: 0,
        reviewing: 0,
        review_rejected: 0,
        pending: 0,
        distribute_failed: 0,
      },
      doudianStatusTabs: [
        { key: 'all', label: '全部商品', countKey: 'total' },
        { key: 'selling', label: '已上架', tabStatus: 'selling', countKey: 'selling' },
        { key: 'warehouse', label: '仓库中', tabStatus: 'warehouse', countKey: 'warehouse' },
        { key: 'draft', label: '草稿箱', tabStatus: 'draft', countKey: 'draft' },
        { key: 'banned', label: '已封禁', tabStatus: 'banned', countKey: 'banned' },
        { key: 'reviewing', label: '审核中', tabStatus: 'reviewing', countKey: 'reviewing' },
        { key: 'review_rejected', label: '审核不通过', tabStatus: 'review_rejected', countKey: 'review_rejected' },
        { key: 'off_shelf_reminder', label: '下架提醒', countKey: null },
        { key: 'pending', label: '待铺货', tabStatus: 'pending', countKey: 'pending' },
        { key: 'distribute_failed', label: '铺货失败', tabStatus: 'distribute_failed', countKey: 'distribute_failed' },
      ],
      queue_num: 0,
      syncSubmitting: false,
      list:[],
      page_data: {
        page_size: 20,
        page: 1,
        total:0,
      },
      dialog: {
        editPriceDialog:false,
      },
      itv_auto_refresh:0,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      urlTo:'',
      // 替换日志相关
      replaceLogShow: false,
      replaceLogLoading: false,
      replaceLogList: [],
      replaceLogPageData: {
        limit: 10,
        page: 1,
        total: 0,
      },
      currentReplaceLogProductId: null,
      productMarkViewShow: false,
      productMarkViewLoading: false,
      productMarkViewItems: [],

      // 低效商品相关
      componentConfig: {
        componentId: 524,
      },//ecopen.bixi组件渲染
      openLoading:false,
      editorVisible: false,
      currentEditProductId: '',
      editorSidebarMode: 'provided',
      editorSidebarItems: [],
    }
  },
  computed: {
    activeDoudianTabConfig() {
      return this.doudianStatusTabs.find(tab => tab.key === this.activeDoudianTab) || this.doudianStatusTabs[0]
    },
  },
  created() {
    // this.getEditUrl()
    // this.initFilterData()
    if (this.$route.query){
      this.searchData =Object.assign(this.searchData,this.$route.query)
      if (this.searchData.shop_id) this.searchData.shop_id = Number(this.searchData.shop_id)
    }
    this.getShop()
    this.getList()
    // this.autoRefresh()
  },
  destroyed() {
    if(this.itv_auto_refresh){
      clearInterval(this.itv_auto_refresh)
    }
  },
  beforeMount(){
    this.getToken().then(data => {
      window.ecopen.start({
        token: data.token.token,
        appId: data.appId,
        shopId: data.shopId,
      });
      this.componentConfig={
        token: data.token.token,
        appId: data.appId,
        shopId: data.shopId,
        componentId: 524
      }
    });
  },
  methods: {
    ...mapActions({
      getGoodsFilterData:"ucenter/getGoodsFilterData",
      getGoodsList:"ucenter/getGoodsList",
      getGoodsStatusStatistics:"ucenter/getGoodsStatusStatistics",
      getGoodsCloudSource:"ucenter/getGoodsCloudSource",
      opBatOnSale:"ucenter/opBatOnSale",
      opBatOffSale:"ucenter/opBatOffSale",
      opProductDel:"ucenter/opProductDel",
      opBatProductEdit:"ucenter/opBatProductEdit",
      opSyncProduct:"ucenter/opSyncDistributeDoudianProducts",
      opBatProductDel:"ucenter/opBatProductDel",
      getProductEditUrl:"ucenter/getProductEditUrl",
      getdeleteAllurl:"ucenter/getdeleteAllurl",
      getDdShopList:"ucenter/getDdShopList",
      productsOperationUp:"ucenter/productsOperationUp",
      doSubmitPH2:"cart/doSubmitPH2",
      getReplaceLogList:"ucenter/getReplaceLogList",
      getProductMarkable: "ucenter/getProductMarkable",
      fetchAuthSuccessShopList: 'ucenter/fetchAuthSuccessShopList',
      fetchShopProductSuggestionList: 'ucenter/fetchShopProductSuggestionList',
      fetchSingleShopInfo: 'index/fetchSingleShopInfo',
    }),
    // 切换店铺类型：1 抖店，7 微信
    bindShopTypeChange(type) {
      if (this.searchData.shop_type === type) return
      this.searchData.shop_type = type
      this.searchData.sales_sort = 0
      if (type === 1) this.activeDoudianTab = 'all'
      // 切换平台时重置店铺选择
      this.searchData.shop_id = undefined
      this.shopList = []
      this.getShop()
      this.handleSearch()
    },
    deleteAll(){
      this.$confirm('确认全部删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {

        this.getdeleteAllurl({data:{state:this.state},success:(res)=>{
            if(res.code === 200){
              this.$message({message: res.msg,type: 'success',});
            }else{
              this.$message({message: res.msg,type: 'error',});
            }
          }})

      }).catch((res) => {
        console.log(res)
      });

    },
    importGoods(){
      console.log(this.searchData.shop_id)
      if(this.searchData.shop_id){
        this.showImportDialog = true;
      }else{
        this.$message({
          message: '请选择店铺',
          type: 'error'
        });
      }
    },
    showError(e){
      if(!e){
        return
      }
      this.$message({
        showClose: true,
        message: e,
        type: 'info'
      });
    },
    showFeatureInProgress(){
      this.$message.info('功能完善中')
    },
    datePick(){
      console.log(111)
    },
    bindSort(){
      let i = this.searchData.sales_sort
      this.searchData.sales_sort = i==0?1:i==1?2:i==2?0:1
      this.getList()
    },
    getProductStatusText(item) {
      if (this.searchData.shop_type === 1) {
        return item.primary_status_text || item.status_text
      }
      return item.status_text
    },
    canOperateProduct(item) {
      if (this.searchData.shop_type === 1) {
        const policy = item.operation_policy || {}
        return Boolean(policy.can_launch || policy.can_offline)
      }
      return [3, 4, 5].includes(item.platform_status)
    },
    getProductOperationText(item) {
      if (this.searchData.shop_type === 1) {
        return item.operation_policy && item.operation_policy.can_offline ? '下架' : '上架'
      }
      return item.platform_status == 4 ? '下架' : '上架'
    },
    openDoudianEditor(item) {
      this.editorSidebarMode = 'provided'
      this.editorSidebarItems = item ? [item] : []
      this.currentEditProductId = item.id
      this.editorVisible = true
    },
    openFilteredDoudianEditor() {
      const currentPageItems = Array.isArray(this.list) ? this.list : []
      if (!currentPageItems.length) {
        this.$message({ message: '当前筛选条件下暂无商品', type: 'warning' })
        return
      }
      const editableItem = currentPageItems.find(item => Number(item.platform_product_id) > 0)
      if (!editableItem) {
        this.$message({ message: '当前筛选商品中没有可编辑的抖店商品', type: 'warning' })
        return
      }
      this.editorSidebarMode = 'search'
      this.editorSidebarItems = []
      this.currentEditProductId = editableItem.id
      this.editorVisible = true
    },
    handleDoudianEditorSaved(data, keepOpen) {
      if (!keepOpen) {
        this.editorVisible = false
      }
      this.refresh()
    },
    handleViewCloudProduct(item) {
      this.getGoodsCloudSource({
        id: item.id,
        success: (res) => {
          if (res.code === 200 && res.data && res.data.source_product_id) {
           /* this.$router.push({
              path: '/uc_product',
              query: {
                tab: 'list',
                source_product_id: res.data.source_product_id
              }
            })*/
            if(res.data.cloud_source_type==='self'){
              window.open('/uc_product?tab=list&source_product_id='+ res.data.source_product_id)
            }else if(res.data.cloud_source_type==='shared'){
              window.open('/uc_product?tab=share&source_product_id='+ res.data.source_product_id)
            }

          } else {
            this.$message({ message: res.msg || '未找到对应云商品', type: 'error' })
          }
        }
      })
    },
    handleViewProductMarks(item) {
      this.productMarkViewShow = true
      this.productMarkViewLoading = true
      this.productMarkViewItems = []
      this.getProductMarkable({
        data: { product_id: item.product_id, shop_id: item.shop_id },
        success: (res) => {
          this.productMarkViewLoading = false
          if (res.code === 200) {
            this.productMarkViewItems = Array.isArray(res.data) ? res.data : []
          } else {
            this.$message.error(res.message || res.msg || '获取标记货源失败')
          }
        }
      })
    },
    openProductMark(item) {
      if (!item || !item.offer_id) return
      window.open(`https://detail.1688.com/offer/${item.offer_id}.html`, '_blank', 'noopener,noreferrer')
    },
    initFilterData(){
      this.getGoodsFilterData({data:this.searchData,success:(res)=>{
          if(res.code===200){
            // console.log('get goods filter data',res)
            this.cateList = res.data.cate_list
            this.shopTypeList = res.data.shop_types
            this.dangkouList = res.data.dangkou_list
          }
        }})
    },
    getShop(){
      this.getDdShopList({data:{shop_type: this.searchData.shop_type},success:(res)=>{
          if(res.code===200){
            this.shopList = res.data.list.list
          }
        }})
    },
    getEditUrl(){
      let param={status:4}
      this.getProductEditUrl({data:param,success:(res)=>{
          if(res.code===200){
            this.urlTo = res.data.url
          }
        }})
    },
    onShopChange(){
      if (this.searchData.shop_type === 1) {
        this.initFilterData()
      }
    },
    clearCheck(){
      this.checkAll = false
      this.checkList = []
    },
    handleSearch(){
      this.page_data.page=1
      this.getList()
    },
    //重置搜索
    resetSearch(){
      const shopType = this.searchData.shop_type
      this.searchData = { shop_type: shopType }
      this.checkAll = false
      this.checkList = []
      // this.onShopChange()
      this.handleSearch()
    },
    //刷新列表
    refresh(){
      this.page_data.page = 1
      this.list = []
      this.checkAll = false
      this.checkList = []
      this.getList()
    },
    //自动刷新
    autoRefresh(){
      let that = this
      // that.itv_auto_refresh = setInterval(function(){
      // 	that.getList(false)
      // },60000)

    },
    postSyncProduct(){
      this.$confirm('确认同步商家全部抖店商品吗？会跳过店铺商品应用异常的商品！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.syncSubmitting = true
        this.opSyncProduct({data:{},success:(res)=>{
            if(res.code === 200){
              this.$message({message: res.msg,type: 'success',});
              this.getList(false)
            }else{
              this.$message({message: res.msg,type: 'error',});
            }
            this.syncSubmitting = false
          }})
      }).catch(() => {
        this.syncSubmitting = false
      })
    },
    //获取商品列表
    getList(showLoading = true){
      if(showLoading) this.isLoading = true
      if (this.searchData.shop_type === 1 && this.activeDoudianTab === 'off_shelf_reminder') {
        this.list = []
        this.page_data.total = 0
        this.clearCheck()
        this.isLoading = false
        return
      }
      let param = {page_size:this.page_data.page_size,page:this.page_data.page,shop_type:this.searchData.shop_type}
      Object.assign(param, this.searchData)
      if (this.searchData.shop_type === 1) {
        delete param.status
        if (this.activeDoudianTabConfig.tabStatus) {
          param.tab_status = this.activeDoudianTabConfig.tabStatus
        } else {
          delete param.tab_status
        }
      } else {
        param.status = this.state
      }
      // console.log(param)
      if (this.searchData.shop_type === 1) {
        const statisticsParam = Object.assign({}, param)
        delete statisticsParam.status
        delete statisticsParam.primary_status
        delete statisticsParam.tab_status
        delete statisticsParam.platform_ban_status
        delete statisticsParam.platform_stock_status
        this.getGoodsStatusStatistics({data:statisticsParam,success:(res)=>{
          if (res.code === 200) {
            this.statusStatistics = Object.assign({}, this.statusStatistics, res.data)
          } else {
            this.$message({message: res.msg || '获取商品状态统计失败', type: 'error'})
          }
        }})
      }
      this.getGoodsList({data:param,success:(res)=>{
          if(res.code===200){
            // console.log('get goods list',res)
            this.list = res.data.list
            this.page_data.total = res.data.pagination.total
            // this.queue_num = res.data.queue_num
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
          this.isLoading = false
        }})
    },
    //切换商品状态
    bindSate(e){
      this.state = e
      this.handleSearch()
    },
    bindDoudianState(tabKey) {
      this.activeDoudianTab = tabKey
      this.handleSearch()
    },
    getDoudianStatusCount(tab) {
      if (!tab.countKey) return '--'
      if (tab.key === 'all') return this.statusStatistics.total || 0
      return this.statusStatistics[tab.countKey] || 0
    },
    //全选
    bindCheckAll(){
      let checkAll = this.checkAll
      let list = this.list
      let checkList = []
      if(checkAll){
        for(var i in list){
          if(checkAll){
            checkList.push(list[i].id)
          }
        }
      }
      this.checkList = checkList
    },
    //单项选
    bindCheckList(){
      let checkList = this.checkList
      if(checkList.length == this.list.length){
        this.checkAll = true
      }else{
        this.checkAll = false
      }
    },
    //批量改价弹窗
    bindBatEditPrice(){
      let checkList = this.checkList
      if(checkList.length == 0){
        this.$message({message: '请勾选商品',type: 'error'})
        return;
      }
      this.dialog.editPriceDialog = true
    },
    //提交批量改价
    postBatEditPrice(e){
      let that = this
      // console.log(e)
      let checkList = this.checkList
      let param = {ids:checkList.join(',')}
      Object.assign(param, e)
      that.opBatProductEdit({data:param,success:(res)=>{
          that.isLoading = false
          that.dialog.editPriceDialog = false
          if(res.code == 200){
            that.$message({
              type: 'success',
              message: res.msg
            })
            that.refresh()
          }else{
            that.$message({
              type: 'error',
              message: res.msg
            })
          }
        }})
    },
    bindOnSale(id){
      this.checkList = [id]
      this.checkAll = false
      this.postBatOnSale()
    },
    //单个上架、下架
    bindSale(product){
      let that = this;
      const newStatus = product.platform_status ==4? 2:1
      let param = ({
        product_ids: [product.id],
        type: newStatus,
        shop_type: this.searchData.shop_type
      })
      that.productsOperationUp({data:param,success:(res)=>{
          // console.log(res)
          if(res.code == 200){
            that.$message({
              type: 'success',
              message: res.msg || res.message
            })
            that.refresh()
          }else{
            that.$message({
              type: 'error',
              message: res.msg|| res.message
            })
          }
        }})
    },
    //批量上架
    postBatOnSale(){
      let that = this
      let checkList = that.checkList
      if(checkList.length == 0){
        that.$message({message: '请勾选商品',type: 'error'})
        return;
      }
      that.$confirm(`确定要批量上架选中的 ${checkList.length} 个商品吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          // product_ids: checkList.filter(p => [3,5].includes(p.platform_status)).map(p => p.id),
          product_ids: checkList,
          type: 1,
          shop_type: that.searchData.shop_type
        }
        let loadingInstance = Loading.service({fullscreen:true,text:'上架中...'});
        that.productsOperationUp({data:param,success:(res)=>{
            loadingInstance.close();
            if(res.code == 200){
              that.$message({
                type: 'success',
                message: res.msg || res.message
              })
              that.refresh()
            }else{
              that.$message({
                type: 'error',
                message: res.msg|| res.message
              })
            }
          }})
      }).catch((res) => {
        console.log(res)
      });
    },
    //批量下架
    postBatOffSale(){
      let that = this
      let checkList = that.checkList
      if(checkList.length == 0){
        that.$message({message: '请勾选商品',type: 'error'})
        return;
      }
      that.$confirm(`确定要批量下架选中的 ${checkList.length} 个商品吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          // product_ids: checkList.filter(p => p.platform_status==4).map(p => p.id),
          product_ids: checkList,
          type: 2,
          shop_type: that.searchData.shop_type
        }
        let loadingInstance = Loading.service({fullscreen:true,text:'下架中...'});
        that.productsOperationUp({data:param,success:(res)=>{
            loadingInstance.close();
            if(res.code == 200){
              that.$message({
                type: 'success',
                message: res.msg || res.message
              })
              that.refresh()
            }else{
              that.$message({
                type: 'error',
                message: res.msg || res.message
              })
            }
          }})
      }).catch((res) => {
        console.log(res)
      });
    },
    //一键重铺
    reSubmit(){
      let that = this
      let checkList = that.checkList
      let tip = ''
      if(checkList.length == 0){
        tip = '确定一键重铺所有失败的商品？每次最多1000条'
      }else{
        tip = '确定重铺勾选的商品？'
      }
      that.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {

        that.$refs.child.showShopList()

      }).catch((res) => {
        console.log(res)
      });
    },

    //提交一键铺货
    phSubmit(val,strategy){
      let that = this
      let ids = this.checkList.join(',')
      let param = {shop_id:val,strategy:strategy,ids:ids}
      this.doSubmitPH2({data:param,success:(res)=>{
          if(res.code===200){
            that.$message({message: res.msg,type: 'success',});
            setTimeout(()=>{
              that.refresh()
              that.$refs.child.closeShopList()
            },300)
          } else {
            that.$message({message: res.msg,type: 'error',});
          }
        }})
    },

    //批量删除
    postBatProductDel(){
      let that = this
      let checkList = that.checkList
      if(checkList.length == 0){
        that.$message({message: '请勾选商品',type: 'error'})
        return;
      }
      that.$confirm(`确定要批量删除选中的 ${checkList.length} 个商品吗？此操作不可恢复！`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          product_ids: checkList,
          type: 3,
          shop_type: that.searchData.shop_type
        }
        let loadingInstance = Loading.service({fullscreen:true,text:'删除中...'});
        that.productsOperationUp({data:param,success:(res)=>{
            loadingInstance.close();
            if(res.code == 200){
              that.$message({
                type: 'success',
                message: res.msg|| res.message
              })
              that.refresh()
            }else{
              that.$message({
                type: 'error',
                message: res.msg|| res.message
              })
            }
          }})
      }).catch((res) => {
        console.log(res)
      });
    },
    //移除商品
    postOpProductDel(product){
      let that = this
      that.$confirm(`确认移除商品「${product.product_title}」吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          product_ids: [product.id],
          type: 3,
          shop_type: that.searchData.shop_type
        }
        let loadingInstance = Loading.service({fullscreen:true,text:'删除中...'});
        that.productsOperationUp({data:param,success:(res)=>{
            loadingInstance.close();
            if(res.code == 200){
              that.$message({
                type: 'success',
                message: res.message
              })
              that.refresh()
            }else{
              that.$message({
                type: 'error',
                message: res.msg || res.message
              })
            }
          }})
      }).catch((res) => {
        console.log(res)
      });
    },
    goToEdit(){
      let that = this
      // let checkList = that.checkList
      // if(checkList.length == 0){
      //   that.$message({message: '请勾选商品',type: 'error'})
      //   return;
      // }
      console.log(this.urlTo)
      window.open(this.urlTo + '&product_ids='+that.checkList.join(','))
      // urlTo
    },
    goToLink(val){
      let that = this
      if(val){
        that.$router.push('./uc_goods_connect?id='+val)
      }else{
        let checkList = that.checkList
        if(checkList.length == 0){
          that.$message({message: '请勾选商品',type: 'error'})
          return;
        }
        // console.log(this.urlTo)
        // window.open(this.urlTo + '&product_ids='+that.checkList.join(','))
        that.$router.push('./uc_goods_connect?id='+that.checkList.join(','))
      }
      // urlTo
    },

    updateMyProduct ( updates){
      let that = this;
      that.productsOperationUp({data:updates,success:(res)=>{
          // console.log(res)
          if(res.code == 200){
            that.$message({
              type: 'success',
              message: res.msg
            })
            that.refresh()
          }else{
            that.$message({
              type: 'error',
              message: res.msg
            })
          }
        }}).catch((res) => {
        console.log(res)
      });
    },

    // 查看替换日志
    handleViewReplaceLogs(item) {
      this.currentReplaceLogProductId = item.product_id
      this.replaceLogPageData.page = 1
      this.replaceLogShow = true
      this.getReplaceLogData()
    },

    // 获取替换日志数据
    getReplaceLogData() {
      this.replaceLogLoading = true
      this.getReplaceLogList({
        data: {
          product_id: this.currentReplaceLogProductId,
          page: this.replaceLogPageData.page,
          page_size: this.replaceLogPageData.limit
        },
        success: (res) => {
          this.replaceLogLoading = false
          if (res.code === 200) {
            this.replaceLogList = res.data.list || []
            this.replaceLogPageData.total = res.data.total || 0
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // === 清理商品 ===
    openCleanBixi() {
      this.getToken().then(data => {
        // 1. 关闭自动弹窗
        window.ecopen.start({
          token: data.token.token,
          appId: data.appId,
          shopId: data.shopId,
          blockedDistributeComponents: [524]
        })
        // 2. 手动触发
        window.ecopen.bixi(document.getElementById('huhu_clean'), {
        componentId: 524,
        extra: {},
      });
    });

    },

    // === 低效商品 ===
    openBixi() {
      // this.openLoading =true
      this.getToken().then(data => {
        // 1. 关闭自动弹窗
        window.ecopen.start({
          token: data.token.token,
          appId: data.appId,
          shopId: data.shopId,
          blockedDistributeComponents: [509]
        })
        // 2. 手动触发
        window.ecopen.bixi(document.getElementById('huhu'), {
        componentId: 509,
        extra: {},
      });
    });

    },

    getToken(){
      return new Promise((resolve)=>{
        const ecopenConfig = localStorage.getItem('ecopenConfig')?JSON.parse(localStorage.getItem('ecopenConfig')):{}
        const now = new Date().getTime()
        if(!ecopenConfig.token || ecopenConfig.token.expire_time*1000 < now){
          this.fetchSingleShopInfo({
            success:(res)=>{
              localStorage.setItem('ecopenConfig',JSON.stringify(res.data))
              resolve(res.data)
            }
          })
        }else{
          resolve(ecopenConfig)
        }
      })
    },


  }
}
</script>

<style scoped>

.center{display: flex;flex: 1;}
.ucenter_main{min-height: 500px;}

.goods_main{padding: 36px 40px 46px;}
.platform_tabs_wrap{width: 100%;height: 50px;border-bottom: 2px solid #eee;display: flex;margin-top: 20px;}
.platform_tabs_wrap .platform_tab{height: 100%;padding: 15px 24px 0;position: relative;line-height: 1;cursor: pointer;font-size: 15px;color: #666;box-sizing: border-box;font-weight: 500;}
.platform_tabs_wrap .platform_tab.active{font-weight: bold;color: var(--red);}
.platform_tabs_wrap .platform_tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: -1px;z-index: 2;border-radius: 2px;}
.select_wrap{margin-top: 24px;}
.select_wrap .search_fields{display: grid;grid-template-columns: repeat(4, minmax(0, 1fr));gap: 14px 24px;}
.select_wrap .search_actions{display: flex;flex-wrap: wrap;gap: 10px;margin-top: 14px;}
.select_wrap .mr{margin-right: 15px;}
.select_wrap .w290{width: 100%;position: relative;}
.select_wrap .cate-label{position: absolute;left: 5px;z-index: 1;}
.el-cascader{line-height: 34px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.select_wrap .source-id-input .label_title{width: 100px;}
@media (max-width: 1400px) {
  .select_wrap .search_fields{grid-template-columns: repeat(2, minmax(0, 1fr));}
}
.tabs_wrap{width: 100%;height: 60px;border-bottom: 1px solid #eee;display: flex;}
.tabs_wrap .tab{height: 100%;padding: 30px 16px 0;position: relative;line-height: 1;cursor: pointer;font-size: 14px;color: #666;box-sizing: border-box;}
.tabs_wrap .tab.active{font-weight: bold;color: var(--red);}
.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.totals_btn .totals{font-size: 12px;color: #333;padding-right: 16px;margin-right: 16px;line-height: 1;border-right: 1px solid #ccc;}
/*.list_title{width: 100%;height: 50px;background: #f9f9f9;margin-top: 10px;display: flex;align-items: center;font-size: 12px;color: #666;}
.list_title .checkall{margin-left: 20px;}
.list_title .t1{margin-left: 40px;!*width: 150px;*!width: 30%;}
.list_title .t2{margin-left: 30px;width: 100px;}
.list_title .t3{margin: 0 20px;width: 50px;text-align: right;}
.list_title .t4{margin: 0 20px;width: 50px;}
.list_title .t5{margin: 0 10px;width: 80px;}
.list_title .t6{margin: 0 20px;width: 60px;}
.list_title .t7{margin: 0 10px;width: 40px;cursor: pointer;position: relative;}*/
.list_title{
  height: 50px;
  background: #f9f9f9;
  margin-top: 10px;
  font-size: 12px;
  color: #666;
  padding: 0 20px;
  display: grid;
/*  grid-template-columns: 50px 1fr 100px 100px 150px 80px 150px 190px;*/
  grid-template-columns: 2.6vw minmax(220px, 1fr) 5.2vw 5.2vw 7.8vw 4.2vw 7.8vw 10vw;
  grid-gap: 15px;
  align-items: center;
}
.list_title .t7{cursor: pointer;position: relative;}
.list_title .t7 .icon-sanjiao{position: absolute;right: 3px;font-size: 10px;color: #ccc;}
.list_title .t7 .up{top: -3px;transform: rotate(180deg) translateX(-.5px) scale(.8);}
.list_title .t7 .down{top: 5px;transform: scale(.8);}
.list_title .t7.up ,.list_title .t7.up .up ,.list_title .t7.down ,.list_title .t7.down .down{color: var(--red);}

.goods_list li{padding: 28px 0;border-bottom: 1px solid #eee;display: flex;align-items: flex-start;font-size: 12px;}
/*.goods_list li .check_box{margin-left: 20px;height: 48px;display: flex;align-items: center;}*/
.goods_list li {
  padding:28px 20px;
  min-height: 48px;
  border-bottom: 1px solid #eee;
  display: grid;
 /* grid-template-columns: 50px 1fr 100px 100px 150px 80px 150px 190px;*/
  grid-template-columns: 2.6vw minmax(220px, 1fr) 5.2vw 5.2vw 7.8vw 4.2vw 7.8vw 10vw;
  grid-gap: 15px;
  align-items: center;
}
:deep(.goods_list li .check_box .el-checkbox__label){display: none !important;}
.goods_list li .goods_info{/* min-width: 207px;*/display: flex;}
.goods_list li .goods_info .img_box{width: 48px;height: 48px;background-color: #eeeeee;border-radius: 6px;overflow: hidden;}
.goods_list li .goods_info .con_box{flex: 1;width: 0;margin-left: 10px;display: flex;flex-direction: column;justify-content: space-between;}
.goods_list li .goods_info .con_box .title{line-height: 16px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
.goods_list li .goods_info .con_box .nums{color: #999999;white-space: nowrap;}
.goods_list li .dp_name{width: 100px;color: #666666;line-height: 16px;margin-left: 30px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
/*.goods_list li .price1{text-align: right;}
.goods_list li .price1 ,.goods_list li .price2{width: 50px;margin: 0 20px;}*/
.goods_list li .status{width: 80px;display: flex;justify-content: flex-start;align-items: center;margin: 0 10px;}
.goods_list li .status i{cursor: pointer;margin-left: 3px;}
.goods_list li .status::before{content: '';width: 8px;height: 8px;border-radius: 50%;margin-right: 6px;}
.goods_list li .status.sales::before{background: #0ea11f;}
.goods_list li .status.xiajia::before{background: #ccc;}
.goods_list li .status.fail::before{background: var(--red);}
.goods_list li .status.fail{color: var(--red);}
.goods_list li .time{line-height: 16px;}
.goods_list li .sales_num{width: 30px;line-height: 16px;margin: 0 20px;}
.goods_list li .last{display: flex;flex-wrap: wrap;justify-content: center;align-items: center;gap: 6px 12px;text-align: center;line-height: 1;}
.goods_list li .last .guanlian{color: #1966ff;cursor: pointer;}
.goods_list li .last .guanlian:hover{text-decoration: underline;}
.goods_list li .last .opts{color: var(--red);cursor: pointer;margin-top: 0;white-space: nowrap;line-height: 16px;}
.goods_list li .last .opts:hover{text-decoration: underline;}

/* 替换日志样式 */
.replace-log-tip {
  color: #909399;
  font-size: 12px;
  margin-bottom: 10px;
}
.replace-log-link {
  color: #409EFF;
  text-decoration: none;
  word-break: break-all;
  display: inline-block;
  max-width: 350px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.replace-log-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}
</style>
<style scoped>
:deep(.el-cascader){width: 100%;}
:deep(.select_wrap .el-button){margin-top: 0;}
:deep(.select_wrap .el-input--prefix .el-input__inner,.select_wrap .el-cascader .el-input .el-input__inner){padding-left: 76px !important;height: 34px;line-height: 34px;font-size: 12px !important;}
:deep(.select_wrap .source-id-input.el-input--prefix .el-input__inner){padding-left: 106px !important;}
:deep(.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus){border-color: var(--red);}
:deep(.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path){color: var(--red);}
:deep(.select_wrap .el-input--prefix .el-input__inner:focus){border-color: var(--red);}
:deep(.el-input__prefix, .el-input__suffix){display: flex;align-items: center;}

:deep(.el-button--small){padding: 7px 10px!important;}
:deep(.el-checkbox){color: #666;display: flex;align-items: center;}
:deep(.el-checkbox__inner){border-color: #ddd;width: 16px;height: 16px;}
:deep(.el-checkbox__input){display: flex;}
:deep(.el-checkbox__label){font-size: 12px;line-height: 1;}
:deep(.el-checkbox__inner::after){height: 9px;left: 5px;}
:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before){height: 4px;}

/*red border color*/
:deep(.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner){border-color: var(--red);}

/*red color*/
:deep(.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover){color: var(--red);}

/*red background color*/
:deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner){background-color: var(--red);}

:deep(.el-button:focus, .el-button:hover){border-color: var(--red);color: var(--red);background:#fff;}
:deep(.el-button--primary){background: var(--red) !important;color: #fff !important;border-color: #fff;}
:deep(.el-button--primary:focus, .el-button:hover){border-color: var(--red);}
:deep(.el-loading-spinner .el-loading-text){color:var(--red);}
:deep(.el-loading-spinner .path){stroke: var(--red);}
</style>
